import { CustomEvents } from '@labradorsports/constants';
import { GeneralErrors, createException } from '@labradorsports/utils';

import { addCordovaHandler, promisify } from '../../../app/utils.js';
import Logger from '../../../shared/logger.js';

export const hasPermission = async (logger: Logger): Promise<boolean> =>
    promisify(window.FirebasexMessaging.hasPermission, logger)();
export const grantPermission = async (logger: Logger): Promise<boolean> =>
    promisify(window.FirebasexMessaging.grantPermission, logger)();

export default function initNotifications(logger: Logger) {
    addCordovaHandler(logger, 'deviceready', () => {
        window.FirebasexMessaging.onMessageReceived(
            (message: any) => {
                if (message.messageType === 'notification' && message.tap) {
                    if (message.minVersion) {
                        const minParts: string[] = message.minVersion.split('.');
                        const versionParts: string[] = VERSION.split('.');

                        if (minParts.some((part, idx) => Number(part) > Number(versionParts[idx]))) {
                            return;
                        }
                    }

                    if (message.targetPath) {
                        window.location.href = `${window.location.origin}${window.location.pathname}#${message.targetPath}`;
                    }

                    window.dispatchEvent(new CustomEvent(CustomEvents.PUSH_NOTIFICATION_TAP, { detail: message }));
                }
            },
            (error: any) => {
                logger.exception(createException(GeneralErrors.UNKNOWN_ERROR, { nestedError: error }));
            }
        );
    });
}

export async function getNotificationPermission(logger: Logger): Promise<boolean> {
    try {
        if (await hasPermission(logger)) {
            return true;
        }

        return grantPermission(logger);
    } catch (error) {
        logger.log('error getting notification permission', { error });
        return false;
    }
}

export async function getFCMToken(logger: Logger): Promise<string> {
    try {
        return promisify(window.FirebasexMessaging.getToken, logger)();
    } catch (error) {
        logger.log('error getting FCM token', { error });
        return null;
    }
}

export function onTokenRefresh(logger: Logger, handler: (token: string) => void): void {
    window.FirebasexMessaging.onTokenRefresh(handler, (error: any) => {
        logger.log('error on token refresh', { error });
    });
}

export function setNotificationBadge(logger: Logger, badgeNumber: number): void {
    addCordovaHandler(logger, 'deviceready', () => {
        window.FirebasexMessaging.setBadgeNumber(
            badgeNumber,
            () => undefined,
            (error: any) => {
                logger.log('error setting notification badge', { error });
            }
        );
    });
}
